<template>
  <div class="retail-connect-unavailable-products-fi__product">
    <div class="retail-connect-unavailable-products-fi__image">
      <cloud-image-fi
        class="retail-connect-cart-products-fi__product__img"
        width="94"
        height="94"
        params="func=fit"
        :src="product.catalogData?.image ? product.catalogData.image : placeholderImage"
      />
    </div>
    <div class="retail-connect-unavailable-products-fi__data">
      <template v-if="product.catalogData">
        <div class="retail-connect-unavailable-products-fi__name">
          {{ product.catalogData.nameLong }}
        </div>
        <div class="retail-connect-unavailable-products-fi__articleNo">
          {{ $dict.get('checkout.Cart.Article-Number') }} {{ product.catalogData.id }}
        </div>
      </template>
      <div
        v-else-if="product.error?.message"
        class="retail-connect-unavailable-products-fi__error"
      >
        {{ product.error.message }}
      </div>
    </div>
  </div>
</template>

<script>
import CloudImageFi from '@/components/atoms/cloud-image-fi/CloudImageFi.vue';
import getAssetUrl from '@/lib/AssetService';

export default {
  name: 'RetailConnectUnavailableProductFi',
  components: {
    CloudImageFi,
  },
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isExpanded: false,
      placeholderImage: getAssetUrl('/img/products/placeholder.svg'),
    };
  },
  computed: {
    isExpandable() {
      return this.products.length > 4;
    },
    visibleProducts() {
      const vProducts = [...this.products];
      return vProducts.slice(0, 4);
    },
    hiddenProducts() {
      const hProducts = [...this.products];
      return hProducts.splice(4);
    },
  },
};
</script>

<style scoped src="./retail-connect-unavailable-products-fi" />
